export const SectionSeparator = () => (
  <div
    style={{
      height: "2px",
      backgroundColor: "#e4e6eb", // Classic FB gray
      width: "100%",
      margin: "0",
    }}
  />
);
